var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10179_17955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18H3.5C1.85 18 0.5 16.65 0.5 15V4C0.5 2.35 1.85 1 3.5 1H7.5C8.05 1 8.5 1.45 8.5 2C8.5 2.55 8.05 3 7.5 3H3.5C2.95 3 2.5 3.45 2.5 4V15C2.5 15.55 2.95 16 3.5 16H14.5C15.05 16 15.5 15.55 15.5 15V11C15.5 10.45 15.95 10 16.5 10C17.05 10 17.5 10.45 17.5 11V15C17.5 16.65 16.15 18 14.5 18Z",
    fill: "#97E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8C16.95 8 16.5 7.55 16.5 7V2H11.5C10.95 2 10.5 1.55 10.5 1C10.5 0.45 10.95 0 11.5 0H17.5C18.05 0 18.5 0.45 18.5 1V7C18.5 7.55 18.05 8 17.5 8Z",
    fill: "#97E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5025 10C9.2425 10 8.9925 9.9 8.7925 9.71C8.4025 9.32 8.4025 8.69 8.7925 8.3L16.7925 0.289998C17.1825 -0.100002 17.8125 -0.100002 18.2025 0.289998C18.5925 0.679998 18.5925 1.31 18.2025 1.7L10.2025 9.7C10.0025 9.9 9.7525 9.99 9.4925 9.99L9.5025 10Z",
    fill: "#97E3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10179_17955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.1bdc953915a32884612f3cc6f2d095d9.svg";
export { ForwardRef as ReactComponent };